import {mapMutations, mapGetters} from 'vuex';
import {
    SHOW_CATALOG_MENU,
} from '@/store/mutation-types';

import CatalogList from '../catalog-list/index.vue';

import { isMobile } from '@/helpers/variables/index'

export default {
    name: 'header-catalog',
    data() {
        return {
            showFirst: false,
        }
    },
    components: {
        CatalogList
    },
    watch: {
      '$route'(){
          if(this.showCatalogMenu){
              this.changeShowCatalogMenu();
          }
      }
    },
    computed: {
        ...mapGetters({
            showCatalogMenu: 'system/showCatalogMenu',
            config: 'setting/menu',
        }),
        isMobile(){
            return isMobile.any();
        }
    },
    methods: {
        ...mapMutations({
            changeShowCatalogMenu: `system/${SHOW_CATALOG_MENU}`
        }),
        changeShowCatalog(){
            if(this.$route.name !== 'home' || this.isMobile){
                this.changeShowCatalogMenu();
            }
        }

    }
}
